import { render } from "./VideoComponent.vue?vue&type=template&id=e3dafe8c&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=e3dafe8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3dafe8c"]])

export default __exports__